export const p = "paragraph";
export const h1 = "heading-1";
export const h2 = "heading-2";
export const h3 = "heading-3";
export const h4 = "heading-4";
export const h5 = "heading-5";
export const h6 = "heading-6";
export const img = "embedded-asset-block";
export const link = "hyperlink";
